export function getValidationErrorMessageId(prefix: string, errorType: string) {
    return `${prefix}_${errorType}`;
}
